module.exports = __webpack_public_path__ + "img/anon_applied_job_logo.cf8bfc4d.svg";